import {
  Equipment,
  GET_CURRENT_FERT_PREDICTION_TECH,
  GET_EQUIPMENT_BY_ID,
  GET_EQUIPMENT_SEARCH_BY_SITE,
  GET_PREDICTION_TECHS,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

interface PredictionTechsResponse {
  equipments: {
    items: Equipment[];
  };
}

interface EquipmentForDropdownResponse {
  equipments: {
    items: Equipment[];
  };
}

interface EquipmentByIdResponse {
  equipments: {
    items: Equipment[];
  };
}

export const equipmentApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getPredictionTechs: build.query({
      query: (variables) => ({
        document: GET_PREDICTION_TECHS,
        variables,
      }),
      transformResponse: (response: PredictionTechsResponse) =>
        response.equipments?.items,
      providesTags: ['PredictionTechs'],
    }),
    getCurrentFertPredictionTech: build.query({
      query: (variables) => ({
        document: GET_CURRENT_FERT_PREDICTION_TECH,
        variables,
      }),
      providesTags: ['CurrentFertPredictionTech'],
    }),
    getEquipmentForDropdown: build.query({
      query: (variables) => ({
        document: GET_EQUIPMENT_SEARCH_BY_SITE,
        variables,
      }),
      transformResponse: (response: EquipmentForDropdownResponse) =>
        response.equipments?.items,
    }),
    getEquipmentById: build.query({
      query: (id: string) => ({
        document: GET_EQUIPMENT_BY_ID,
        variables: { id },
      }),
      transformResponse: (response: EquipmentByIdResponse) =>
        response.equipments?.items?.[0],
    }),
  }),
});

export const {
  useGetPredictionTechsQuery,
  useGetCurrentFertPredictionTechQuery,
  useLazyGetPredictionTechsQuery,
  useGetEquipmentForDropdownQuery,
  useGetEquipmentByIdQuery,
} = equipmentApi;
